import {RestService} from "@/services/rest/RestService";
import {ContentBlockInRowEndpointsApi} from "@/api/pharma-cms-content-page";
import {
    ContentBlockInRowRestDto,
    ContentVisibilityRuleForElementRestDto,
    ElementTargetPositionRestDto
} from "@/api/pharma-cms-content-page/models";
import {ContentBlockInRowCreateRestDtoModel} from "@/models/ContentBlockInRowCreateRestDtoModel";
import {MoveActionEnum} from "@/models/enum/MoveActionEnum";

export class ContentBlockInRowRestService extends RestService {

    private apiService: ContentBlockInRowEndpointsApi;

    protected constructor() {
        super();

        this.apiService = new ContentBlockInRowEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cmsUrl);
    }

    public async getContentBlockInRowVisibilityRule(rowId: string, cbInRowId: string): Promise<ContentVisibilityRuleForElementRestDto> {
        const response = await this.apiService.getContentBlockInRowVisibilityRule(rowId, cbInRowId);

        return response.data;
    }

    public async updateContentBlockInRowVisibilityRule(visibilityRuleForElement: ContentVisibilityRuleForElementRestDto, rowId: string, cbInRowId: string): Promise<void> {
        await this.apiService.updateContentBlockInRowVisibilityRule(visibilityRuleForElement, rowId, cbInRowId);
    }

    public async getContentBlockInRow(rowId: string, cbInRowId: string): Promise<ContentBlockInRowRestDto> {
        const response = await this.apiService.getContentBlockInRow(rowId, cbInRowId);

        return response.data;
    }

    public async updateContentBlockInRow(cbInRow: ContentBlockInRowRestDto, rowId: string, cbInRowId: string): Promise<void> {
        await this.apiService.updateContentBlockInRow(cbInRow, rowId, cbInRowId);
    }

    public async createContentBlockInRow(cbInRow: ContentBlockInRowCreateRestDtoModel, rowId: string): Promise<string> {
        const response = await this.apiService.createContentBlockInRow(cbInRow, rowId);

        return response.data.id as string;
    }

    public async copyContentBlockInRow(rowId: string, cbInRowId: string): Promise<void> {
        // An empty target position means "right after the block being copied".
        await this.apiService.copyContentBlockInRow({} as ElementTargetPositionRestDto, rowId, cbInRowId);
    }

    public async deleteContentBlockInRow(rowId: string, cbInRowId: string): Promise<void> {
        await this.apiService.deleteContentBlockInRow(rowId, cbInRowId);
    }

    public async moveContentBlockInRow(rowId: string, cbInRowId: string, moveAction: MoveActionEnum): Promise<void> {
        switch (moveAction) {
            case MoveActionEnum.TOP:
                await this.apiService.moveContentBlockInRowToTop(rowId, cbInRowId);
                break;
            case MoveActionEnum.BOTTOM:
                await this.apiService.moveContentBlockInRowToBottom(rowId, cbInRowId);
                break;
            case MoveActionEnum.UP:
                await this.apiService.moveContentBlockInRowUp(rowId, cbInRowId);
                break;
            case MoveActionEnum.DOWN:
                await this.apiService.moveContentBlockInRowDown(rowId, cbInRowId);
                break;
            default:
                throw new Error('Unsupported moveAction to call ' + moveAction);
        }
    }
}
